import axios from "axios";

export type Organization = {
  path: string;
  title: string;
  apply_path: string;
};

export const lookupOrgByHostname = async (
  hostname: string
): Promise<Organization> => {
  const URL = import.meta.env.VITE_PIPELINE_ENDPOINT;
  if (!URL) return Promise.reject();

  const path = `${URL}/lookup`;
  return await axios.post(path, { hostname: hostname }).then(({ data }) => {
    return data;
  });
};

export const getOrg = async (
  orgPath: string | undefined
): Promise<Organization> => {
  // comment this out to bypass hostname lookup.
  // return {
  //   path: "boston",
  //   title: "Boston testing",
  //   apply_path: "boston",
  // };
  if (!orgPath) throw new Error(`Organization path is undefined`);
  const URL = import.meta.env.VITE_PIPELINE_ENDPOINT;
  if (!URL) return Promise.reject();

  const url = `${URL}/organizations/${orgPath}`;
  return await axios.get(url).then(({ data }) => {
    return data;
  });
};
